import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Cleanup any previously registered service workers so preview and published app always use fresh data.
navigator.serviceWorker?.getRegistrations().then((registrations) => {
  registrations.forEach((registration) => registration.unregister());
});

if ("caches" in window) {
  caches.keys().then((keys) => Promise.all(keys.map((key) => caches.delete(key))));
}

createRoot(document.getElementById("root")!).render(<App />);

